
import { useParams } from 'react-router-dom';
import { useState } from 'react';

import DatePicker from "react-multi-date-picker"
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"

import { FcMediumPriority, FcSerialTasks, FcOk, FcHighPriority } from "react-icons/fc"
import { FiSmartphone, FiDollarSign, FiCreditCard } from "react-icons/fi"
import { useEffect } from 'react';
import axios from 'axios';
import { PayWithdrawal, WithdrawalType } from './../../../api/api';
import { toast } from 'react-toastify';
import Loading from '../../Loading';


const separate = (Number) => {
     Number += '';
     Number = Number.replace(',', '');
     let x = Number.split('.');
     let y = x[0];
     let z = x.length > 1 ? '.' + x[1] : '';
     var rgx = /(\d+)(\d{3})/;
     while (rgx.test(y))
          y = y.replace(rgx, '$1' + ',' + '$2');
     return y + z;
}


const PayRequest = () => {

     const params = useParams()

     const [loading, setLoading] = useState(false)
     const [isLoading, setIsLoading] = useState(false)
     const [dateVal, setDateVal] = useState('')
     const [toman, setToman] = useState('')
     const [status, setStatus] = useState([])
     const [data, setdata] = useState([])
     const [swithdrawalType, setswithdrawalType] = useState(0)
     const [descriptions, setDescriptions] = useState('')

     const hancleChangeWithdrawalType = (e) => {
          setswithdrawalType(e.target.value);
     }

     const handleChangeDate = (value) => {
          let year = value.year
          let month = (value.month < 10 ? '0' + value.month : value.month)
          let day = (value.day < 10 ? '0' + value.day : value.day)
          let hour = (value.hour < 10 ? '0' + value.hour : value.hour)
          let minute = (value.minute < 10 ? '0' + value.minute : value.minute)
          let second = (value.second < 10 ? '0' + value.second : value.second)
          let date = year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second
          setDateVal(date)
     }


     const handleChangeToman = (e) => {
          setToman(e.target.value !== '' ? e.target.value : 0)
     }


     const handleSubmitForm = async (e) => {
          e.preventDefault()
          const putData = {
               withdrawalType: parseInt(swithdrawalType),
               description: e.target.description.value,
               payDate: dateVal,
               trackingCode: e.target.payCode.value,
               price: parseInt(e.target.requestToman.value)
          }

          try {
               setLoading(true)
               await axios.put(PayWithdrawal(params.requestId), putData)
               toast.success('اطلاعات پرداخت با موفقیت ثبت شد!')
          } finally { setLoading(false) }
     }


     useEffect(() => {
          const GET_STATUS = async () => {
               try {
                    setIsLoading(true)
                    const res = await axios.get(WithdrawalType)
                    setStatus(res.data)

                    const getData = await axios.get(PayWithdrawal(params.requestId))

                    setDescriptions(getData.data.description);
                    setswithdrawalType(getData.data.withdrawalType.id)
                    setdata(getData.data)
                    setToman(getData.data.price)
               } finally {
                    setIsLoading(false)
               }
          }
          GET_STATUS()
     }, [])


     return (
          <div className="contentHolder">

               {isLoading ? <Loading styles={'mini'} /> : (
                    <>
                         <div className="itemBox">
                              <div className="dtr">
                                   <div className="flex">

                                        <div className="posterItem" style={{ fontSize: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                             {data?.withdrawalType?.id == 0 && <FcMediumPriority />}
                                             {data?.withdrawalType?.id == 1 && <FcSerialTasks />}
                                             {data?.withdrawalType?.id == 2 && <FcOk />}
                                             {data?.withdrawalType?.id == 3 && <FcHighPriority />}
                                        </div>

                                        <div className="contentItem">

                                             <p className="title">
                                                  <span className="ltr ellipsis" style={{ float: 'right', marginLeft: '10px' }}>{data?.user?.firstName}</span>
                                                  {data?.user?.lastName && (<><small className="ellipsis">({data?.user?.lastName})</small></>)}
                                             </p>

                                             <p className="">
                                                  <FiSmartphone />
                                                  {data?.user?.userName}
                                             </p>
                                             <p className="">
                                                  <FiDollarSign />
                                                  مبلغ : {separate(data?.price)} تومان
                                             </p>

                                             <p className="cats">
                                                  <FiCreditCard />
                                                  شبا : <span className='ltr' style={{ letterSpacing: '1px', marginRight: '5px' }}>IR {data?.user?.shebaNumber}</span>
                                             </p>


                                        </div>
                                   </div>
                              </div>

                         </div>

                         <div className="row">
                              <div className="col-12">
                                   <div className="box_radios">
                                        <div className="headHolder bordered"><p className="title">ثبت اطلاعات پرداخت</p></div>
                                        <form onSubmit={handleSubmitForm} style={{ padding: '20px' }}>


                                             <div className="row">
                                                  <div className="col-8 mb-3">
                                                       <input type="number" defaultValue={toman} onChange={handleChangeToman} name='requestToman' placeholder='مبلغ واریزی را به تومان وارد نمایید' />
                                                       <span style={{ fontWeight: 300, fontSize: '14px' }}>مبلغ تسویه شده <small style={{ fontSize: '16px', fontWeight: 'normal' }}>{separate(toman)}</small> تومان میباشد.</span>
                                                  </div>

                                                  <div className="col-4 mb-3">
                                                       <label style={{ fontSize: '14px' }}>وضعیت : {' '}
                                                            <select onChange={hancleChangeWithdrawalType} name="withdrawalType" id="withdrawalType" defaultValue={swithdrawalType} style={{ width: 'calc(100% - 60px)', padding: '0.5rem', fontSize: '16px', border: '2px solid #d1d3d9', margin: '10px 0' }}>
                                                                 {status && status.map(type => (
                                                                      <option key={type.id} value={type.id}>{type.title}</option>
                                                                 ))}
                                                            </select>
                                                       </label>
                                                  </div>
                                             </div>

                                             <div className="row">
                                                  <div className="col-md-6 mb-3">
                                                       <input type="text" name='payCode' placeholder='کد پیگیری' defaultValue={data?.trackingCode} />
                                                  </div>
                                                  <div className="col-md-6 mb-3">
                                                       <DatePicker
                                                            required
                                                            // value={data?.regDate}
                                                            format="MM/DD/YYYY HH:mm:ss"
                                                            placeholder='تاریخ پرداخت'
                                                            plugins={[<TimePicker position="bottom" />]}
                                                            calendar={persian}
                                                            locale={persian_fa}
                                                            onChange={handleChangeDate}
                                                            calendarPosition="bottom-right"
                                                       />
                                                  </div>
                                             </div>

                                             <div className="row">
                                                  <div className="col-md-12 mb-3">
                                                       <textarea name="description" defaultValue={descriptions} id="description" cols="30" rows="3" placeholder='توضیحات...'></textarea>
                                                  </div>
                                             </div>

                                             {loading
                                                  ?
                                                  (<button type="button" style={{ padding: '1rem 2rem' }} className='disabled'>لطفا صبر کنید...</button>)
                                                  :
                                                  (<input type="submit" value="ثبت" />)
                                             }


                                        </form>
                                   </div>
                              </div>
                         </div>
                    </>
               )}
          </div>
     )
}

export default PayRequest